import { Col as AntCol, Row as AntRow } from 'antd'
import type { ColProps, RowProps } from 'antd'

// Wrapper layout Grid: bọc AntD Row/Col để features/pages không import trực tiếp 'antd'
// (hard-rule module-authoring #1). Pass-through, không thêm hành vi.
export function UiRow(props: RowProps) {
  return <AntRow {...props} />
}

export function UiCol(props: ColProps) {
  return <AntCol {...props} />
}
